module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "fullscreen": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('v-list', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile', [_c('v-list-tile-action', [(_vm.value) ? _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("person")]) : _c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("person_outline")])], 1), _c('v-list-tile-title', [(_vm.value) ? _c('span', {
    staticClass: "player-name"
  }, [_vm._v(_vm._s(_vm.value.name))]) : _c('span', [_vm._v("Select a player")])])], 1)], 1), _c('v-card', [_c('v-toolbar', [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        _vm.isOpen = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _c('v-toolbar-title', [_vm._v("Select a player")])], 1), _c('v-card-text', {
    staticClass: "dialog-contents"
  }, [_c('v-list', _vm._l((_vm.options), function(player) {
    return _c('v-list-tile', {
      key: player.id,
      on: {
        "click": function($event) {
          _vm.select(player)
        }
      }
    }, [_c('v-list-tile-title', [_c('span', {
      staticClass: "player-name"
    }, [_vm._v(_vm._s(player.name))])])], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3d05d48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.common/ui/players/selector.vue
// module id = 351
// module chunks = 0